import { render, staticRenderFns } from "./PromotionsToolbar.vue?vue&type=template&id=35c67c58&scoped=true&"
import script from "./PromotionsToolbar.vue?vue&type=script&lang=js&"
export * from "./PromotionsToolbar.vue?vue&type=script&lang=js&"
import style0 from "./PromotionsToolbar.vue?vue&type=style&index=0&id=35c67c58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c67c58",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35c67c58')) {
      api.createRecord('35c67c58', component.options)
    } else {
      api.reload('35c67c58', component.options)
    }
    module.hot.accept("./PromotionsToolbar.vue?vue&type=template&id=35c67c58&scoped=true&", function () {
      api.rerender('35c67c58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/organization/promotions/components/PromotionsToolbar.vue"
export default component.exports